import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesToolsCustDetails from '@/employee/enquiries/customerDetails/enquiriesToolsCustDetails';

enum CustomerAccountStatus {
  Active = 0,
  Closed = 1,
}

enum AccountType {
  SingleAccount = 0,
  SubAccount = 1,
  GroupAccount = 2,
}

enum CustomerGender {
  None = 0,
  Male = 1,
  Female = 2,
}

export default {
  name: 'CustDetappsOwnedPropsLogDepositsDM',
    components: {
      DataGridComp: require('@/customcontrols/datagrid.vue').default,
      EventLogComp: require('@/employee/enquiries/customerEventLog/customerEventLog.vue').default,
      LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
      EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
      CustomerApplication: require('@/employee/enquiries/customerDetailsApplications/customerDetailsApplications.vue').default,
  },
  mixins: [users, enquiriesToolsCustDetails],
  data: function () {
    return {
      pagesLoaded: ['applications', 'ownedProperties', 'eventLog', 'deposits', 'dmCases'],

      ownedProperties: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "caseId",
        isLoading: true,
      },
      deposits: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "caseId",
        isLoading: true,
      },
      dmCases: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "caseId",
        isLoading: true,
      },
    }
  },
  created() {
    this.selectedTab = 'ownedProperties';
    this.fillGridColumns();
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
  },
  mounted() {
    this.menuVisible = this.getFromLocal('_enquries_cust_det');
  },
  computed: {
    isLoading: function () {
      return this.ownedProperties.isLoading || this.deposits.isLoading || this.dmCases.isLoading;
    },
    isRtl: function () {
      return this.lang == 'ar' ? true : false
    },
    selectedTabObj: function() {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    },
    empName: function () {
      return this.customerDisplayInfo && this.customerDisplayInfo.stampUser ? this.customerDisplayInfo.stampUser : null;
    }
  },
  watch: {
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        case 'history':
        default:
         this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    },
  },
  methods: {
    init() {
      this.fillGridColumns();
      this.getData();
    },
    getData() {
      this.fillDeposits();
      this.fillDmCases();   
      this.fillOwnedProperties();
    },

    fillGridColumns() {
      this.deposits.cols.length = 0;
      this.dmCases.cols.length = 0;
      this.ownedProperties.cols.length = 0;

      this.deposits.cols.push({ dataField: 'property', caption: this.$t('enquiriesCustomerDetails.property') });
      this.deposits.cols.push({ dataField: 'amount', caption: this.$t('enquiriesCustomerDetails.amount') });
      this.deposits.cols.push({ dataField: 'refunded', caption: this.$t('enquiriesCustomerDetails.refunded') });

      this.dmCases.cols.push({ dataField: 'caseId', caption: this.$t('enquiriesCustomerDetails.caseNo') });
      this.dmCases.cols.push({ dataField: 'status', caption: this.$t('enquiriesCustomerDetails.status') });
      this.dmCases.cols.push({ dataField: 'activityStage', caption: this.$t('enquiriesCustomerDetails.stage') });
      this.dmCases.cols.push({ dataField: 'openDate', caption: this.$t('enquiriesCustomerDetails.OpenDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      
      this.ownedProperties.cols.push({ dataField: 'ref', caption: this.$t('captureMR.propertyRef') });
      this.ownedProperties.cols.push({ dataField: 'share', caption: this.$t('enquiriesCustomerDetails.Share') });
    },

    fillDeposits(loading = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.deposits.pageingOption
      }

      if (loading)
        this.deposits.isLoading = true;

      axios.post('/Enquiries/getCustomerDeposits', parameters)
        .then(response => {
          if (response.status == 200) {
            this.deposits.data = response.data.items;

            this.deposits.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.deposits.isLoading = false);
    },
    depositSelected(item) {
     //TBI download deposit
    },

    fillDmCases(loading = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.dmCases.pageingOption
      }

      if (loading)
        this.dmCases.isLoading = true;
      axios.post('/Enquiries/getCustomerDmCases', parameters)
        .then(response => {
          if (response.status == 200) {
            response.data.items.sort((a, b) => (a.caseId > b.caseId) ? -1 : 1);
            this.dmCases.data = response.data.items;

            this.dmCases.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.dmCases.isLoading = false);
    },
    dmSelected(item) {
      //TBI download deposit
    },

    fillOwnedProperties(loading = true) {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.ownedProperties.pageingOption
      }

      if (loading)
        this.ownedProperties.isLoading = true;
      axios.post('/Enquiries/getOwnedProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.ownedProperties.data = response.data.items;

            this.ownedProperties.totalRow = response.data.itemsCount;
          }
        })
        .catch(e => { })
        .finally(() => this.ownedProperties.isLoading = false);
    },

    propertySelected(item) {
      this.openNewWindow(`/propertyDetails/${item.data.propertyId}`);
    },
  }
}

